/** Mirrors `js/shared/dashboard-router.js` titles. */
export const DASHBOARD_PAGE_TITLES: Record<string, string> = {
  'playlist-manager': 'Playlist manager',
  'channel-basic': 'Basic editor',
  'channel-number': 'Number editor',
  'channel-logo': 'Logo editor',
  'channel-epg': 'EPG editor',
  'channel-category': 'Category editor',
  'channel-manual': 'Manual updater',
  'channel-recycle': 'Recycle bin',
  'movie-basic': 'Movie basic editor',
  'movie-cover': 'Cover editor',
  'movie-info': 'Info search',
  'movie-category': 'Category editor',
  'movie-updater': 'Manual updater',
  'movie-recycle': 'Recycle bin',
  'series-basic': 'Series basic editor',
  'series-cover': 'Cover editor',
  'series-info': 'Info search',
  'series-category': 'Category editor',
  'series-updater': 'Manual updater',
  'series-recycle': 'Recycle bin',
  'user-manage': 'Manage users',
  'user-new': 'New user',
  'auto-sources': 'Auto updater',
  'auto-new': 'New updater source',
};

/** Top bar icon + style (matches legacy `#pageTitle` / sidenav). */
export const PAGE_TITLE_ICONS: Record<string, { icon: string; style: 'fas' | 'far' | 'fab' }> = {
  'playlist-manager': { icon: 'fa-save', style: 'far' },
  'channel-basic': { icon: 'fa-pencil-alt', style: 'fas' },
  'channel-number': { icon: 'fa-sort-numeric-down', style: 'fas' },
  'channel-logo': { icon: 'fa-image', style: 'fas' },
  'channel-epg': { icon: 'fa-calendar-alt', style: 'fas' },
  'channel-category': { icon: 'fa-object-group', style: 'fas' },
  'channel-manual': { icon: 'fa-sync-alt', style: 'fas' },
  'channel-recycle': { icon: 'fa-trash-alt', style: 'fas' },
  'movie-basic': { icon: 'fa-pencil-alt', style: 'fas' },
  'movie-cover': { icon: 'fa-image', style: 'far' },
  'movie-info': { icon: 'fa-info-circle', style: 'fas' },
  'movie-category': { icon: 'fa-object-group', style: 'far' },
  'movie-updater': { icon: 'fa-sync-alt', style: 'fas' },
  'movie-recycle': { icon: 'fa-trash-alt', style: 'fas' },
  'series-basic': { icon: 'fa-pencil-alt', style: 'fas' },
  'series-cover': { icon: 'fa-image', style: 'far' },
  'series-info': { icon: 'fa-info-circle', style: 'fas' },
  'series-category': { icon: 'fa-object-group', style: 'far' },
  'series-updater': { icon: 'fa-sync-alt', style: 'fas' },
  'series-recycle': { icon: 'fa-trash-alt', style: 'fas' },
  'user-manage': { icon: 'fa-users', style: 'fas' },
  'user-new': { icon: 'fa-plus', style: 'fas' },
  'auto-sources': { icon: 'fa-link', style: 'fas' },
  'auto-new': { icon: 'fa-plus', style: 'fas' },
};

export const KNOWN_EDITOR_PAGES = new Set(Object.keys(DASHBOARD_PAGE_TITLES));
